// extracted by mini-css-extract-plugin
export default {"pb_border":"ProgressBar_pb_border__cqYLK","pb_fill":"ProgressBar_pb_fill__AHnIE"};